export const appConfig = {
  gtmContainerId: process.env.REACT_APP_GTM_CONTAINER_ID,
  backendApiHostname: process.env.REACT_APP_BACKEND_API_HOSTNAME || 'https://localhost:8000',
};
